var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ScrollSpy_instances, _ScrollSpy_navRootElement, _ScrollSpy_navTrackElements, _ScrollSpy_observerOptions, _ScrollSpy_isScrollingToTarget, _ScrollSpy_firstTrackedId, _ScrollSpy_lastTrackedId, _ScrollSpy_timeout, _ScrollSpy_resetScrollEnd, _ScrollSpy_setActive, _ScrollSpy_scrollToActiveItem, _ScrollSpy_setIds, _ScrollSpy_initNavClicks, _ScrollSpy_pauseObserver, _ScrollSpy_initObserver;
const DEFAULT_OBSERVER_OPTIONS = {
    root: null,
    rootMargin: '0px',
    threshold: 0,
};
const ACTIVE_CLASS = 'active';
class ScrollSpy {
    constructor(navRootElement, navTrackElements, observerOptions) {
        _ScrollSpy_instances.add(this);
        _ScrollSpy_navRootElement.set(this, void 0);
        _ScrollSpy_navTrackElements.set(this, void 0);
        _ScrollSpy_observerOptions.set(this, void 0);
        _ScrollSpy_isScrollingToTarget.set(this, false);
        _ScrollSpy_firstTrackedId.set(this, '');
        _ScrollSpy_lastTrackedId.set(this, '');
        _ScrollSpy_timeout.set(this, void 0);
        _ScrollSpy_resetScrollEnd.set(this, void 0);
        __classPrivateFieldSet(this, _ScrollSpy_observerOptions, Object.assign(Object.assign({}, DEFAULT_OBSERVER_OPTIONS), observerOptions), "f");
        if (!navTrackElements.length)
            throw new Error('ScrollSpy: trackElements is not found');
        if (!navRootElement)
            throw new Error('ScrollSpy: navRootElement is not found');
        __classPrivateFieldSet(this, _ScrollSpy_navTrackElements, navTrackElements, "f");
        __classPrivateFieldSet(this, _ScrollSpy_navRootElement, navRootElement, "f");
        __classPrivateFieldGet(this, _ScrollSpy_instances, "m", _ScrollSpy_setIds).call(this);
        __classPrivateFieldGet(this, _ScrollSpy_instances, "m", _ScrollSpy_initObserver).call(this);
        __classPrivateFieldGet(this, _ScrollSpy_instances, "m", _ScrollSpy_initNavClicks).call(this);
    }
}
_ScrollSpy_navRootElement = new WeakMap(), _ScrollSpy_navTrackElements = new WeakMap(), _ScrollSpy_observerOptions = new WeakMap(), _ScrollSpy_isScrollingToTarget = new WeakMap(), _ScrollSpy_firstTrackedId = new WeakMap(), _ScrollSpy_lastTrackedId = new WeakMap(), _ScrollSpy_timeout = new WeakMap(), _ScrollSpy_resetScrollEnd = new WeakMap(), _ScrollSpy_instances = new WeakSet(), _ScrollSpy_setActive = function _ScrollSpy_setActive(targetId) {
    ;
    [...__classPrivateFieldGet(this, _ScrollSpy_navRootElement, "f").children].forEach(child => {
        const isActive = child.dataset.id === targetId;
        child.classList.toggle(ACTIVE_CLASS, isActive);
        if (isActive)
            __classPrivateFieldGet(this, _ScrollSpy_instances, "m", _ScrollSpy_scrollToActiveItem).call(this, child);
    });
}, _ScrollSpy_scrollToActiveItem = function _ScrollSpy_scrollToActiveItem(child) {
    const clientWidth = __classPrivateFieldGet(this, _ScrollSpy_navRootElement, "f").clientWidth;
    const navScrollLeft = __classPrivateFieldGet(this, _ScrollSpy_navRootElement, "f").scrollLeft;
    const childOffsetLeft = child.getBoundingClientRect().left -
        __classPrivateFieldGet(this, _ScrollSpy_navRootElement, "f").getBoundingClientRect().left +
        navScrollLeft;
    const childOffsetWidth = child.offsetWidth;
    const isVisible = childOffsetLeft >= navScrollLeft &&
        childOffsetLeft + childOffsetWidth <= clientWidth + navScrollLeft;
    if (isVisible)
        return;
    const targetScrollLeft = childOffsetLeft - (clientWidth - childOffsetWidth) / 2;
    __classPrivateFieldGet(this, _ScrollSpy_navRootElement, "f").scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth',
    });
}, _ScrollSpy_setIds = function _ScrollSpy_setIds() {
    var _a, _b, _c, _d;
    const navTrackElements = [...__classPrivateFieldGet(this, _ScrollSpy_navTrackElements, "f")];
    __classPrivateFieldSet(this, _ScrollSpy_firstTrackedId, (_b = (_a = navTrackElements.at(0)) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '', "f");
    __classPrivateFieldSet(this, _ScrollSpy_lastTrackedId, (_d = (_c = navTrackElements.at(-1)) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : '', "f");
}, _ScrollSpy_initNavClicks = function _ScrollSpy_initNavClicks() {
    ;
    [...__classPrivateFieldGet(this, _ScrollSpy_navRootElement, "f").children].forEach(child => {
        child.addEventListener('click', () => {
            const targetId = child.getAttribute('data-id');
            if (!targetId)
                return;
            __classPrivateFieldGet(this, _ScrollSpy_instances, "m", _ScrollSpy_setActive).call(this, targetId);
            __classPrivateFieldGet(this, _ScrollSpy_instances, "m", _ScrollSpy_pauseObserver).call(this);
        });
    });
}, _ScrollSpy_pauseObserver = function _ScrollSpy_pauseObserver() {
    __classPrivateFieldSet(this, _ScrollSpy_isScrollingToTarget, true, "f");
    clearTimeout(__classPrivateFieldGet(this, _ScrollSpy_timeout, "f"));
    if (__classPrivateFieldGet(this, _ScrollSpy_resetScrollEnd, "f"))
        document.removeEventListener('scrollend', __classPrivateFieldGet(this, _ScrollSpy_resetScrollEnd, "f"));
    const resumeObserver = () => {
        __classPrivateFieldSet(this, _ScrollSpy_isScrollingToTarget, false, "f");
        clearTimeout(__classPrivateFieldGet(this, _ScrollSpy_timeout, "f"));
    };
    __classPrivateFieldSet(this, _ScrollSpy_resetScrollEnd, resumeObserver, "f");
    document.addEventListener('scrollend', resumeObserver, { once: true });
    __classPrivateFieldSet(this, _ScrollSpy_timeout, setTimeout(resumeObserver, 1500), "f");
}, _ScrollSpy_initObserver = function _ScrollSpy_initObserver() {
    const callback = (entries) => {
        if (__classPrivateFieldGet(this, _ScrollSpy_isScrollingToTarget, "f"))
            return;
        const intersectedEntries = entries.filter(entry => entry.isIntersecting);
        if (intersectedEntries.length) {
            const id = intersectedEntries.at(-1).target.id;
            __classPrivateFieldGet(this, _ScrollSpy_instances, "m", _ScrollSpy_setActive).call(this, id);
            return;
        }
        // нижній край вище верхньої межі вʼюпорту → елемент над нами (вже пройдений)
        const passedEntries = entries.filter(entry => entry.rootBounds &&
            entry.boundingClientRect.bottom < entry.rootBounds.top);
        // нижній край нижче верхньої межі вʼюпорту → елемент під нами
        const belowEntries = entries.filter(entry => entry.rootBounds &&
            entry.boundingClientRect.bottom > entry.rootBounds.top);
        // lastId пройшов вгору → юзер за останньою секцією; firstId опустився вниз → юзер перед першою
        if (passedEntries.some(e => e.target.id === __classPrivateFieldGet(this, _ScrollSpy_lastTrackedId, "f")) ||
            belowEntries.some(e => e.target.id === __classPrivateFieldGet(this, _ScrollSpy_firstTrackedId, "f"))) {
            __classPrivateFieldGet(this, _ScrollSpy_instances, "m", _ScrollSpy_setActive).call(this, '');
            return;
        }
    };
    const observer = new IntersectionObserver(callback, __classPrivateFieldGet(this, _ScrollSpy_observerOptions, "f"));
    __classPrivateFieldGet(this, _ScrollSpy_navTrackElements, "f").forEach(el => observer.observe(el));
};
export default ScrollSpy;
